import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
var InputWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  max-height: 200px;\n  overflow: scroll;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 20px;\n"])));
var SubmitButton = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 10%;\n"])));
var TextArea = styled.textarea(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: #565867;\n  outline: none;\n  padding: 12px;\n  white-space: pre-wrap;\n  width: 90%;\n  word-wrap: break-word;\n"])));

function ChatAreaInput(props) {
  var _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? 'Add your comment...' : _props$defaultValue,
      handlePostFeedback = props.handlePostFeedback;

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleChange = function handleChange(e) {
    setValue(e.target.value);
  };

  var handleMouseDown = function handleMouseDown() {
    if (value === defaultValue) {
      setValue('');
    }
  };

  var handleOnBlur = function handleOnBlur() {
    if (value === '') {
      setValue(defaultValue);
    }
  };

  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  var handleSubmit = function handleSubmit() {
    handlePostFeedback(value);
    setValue(defaultValue);
  };

  return /*#__PURE__*/React.createElement(InputWrap, null, /*#__PURE__*/React.createElement(TextArea, {
    onBlur: handleOnBlur,
    onChange: handleChange,
    onKeyPress: handleOnKeyDown,
    onClick: handleMouseDown,
    style: value === defaultValue ? {
      color: '#8b8b8b'
    } : {
      color: '#333333'
    },
    value: value,
    className: "chatAreaInput"
  }), /*#__PURE__*/React.createElement(SubmitButton, null, /*#__PURE__*/React.createElement("i", {
    className: "icon ion-android-send",
    onClick: function onClick() {
      handleSubmit();
    },
    style: {
      color: '#616161',
      cursor: 'pointer',
      fontSize: 24
    }
  })));
}

export default ChatAreaInput;